import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { isSingleCardRoute } from 'lib/liveBlog';
import { publicoHeadlineBrands } from 'lib/vertical';

const ArticleHeroHeadline = ({
  children,
  className,
  dek,
  isShoppingSection,
  path,
  vertical,
  isLiveBlog,
}) => {
  const HeadlineTagName = isSingleCardRoute(path) ? 'h2' : 'h1';

  let liveBlogHeader;
  let modifiedChildren;
  if (isLiveBlog) {
    const [liveBlogHeadline, _, headline] = children;
    liveBlogHeader = liveBlogHeadline;
    modifiedChildren = [_, headline];
  }

  const shouldDisplayLiveBlogHeader = isLiveBlog && liveBlogHeader;
  const childrenToRender = modifiedChildren || children;
  const liveBlogDekStyle = isLiveBlog ? 'mt3' : '';

  return (
    <div
      className={classNames(
        'article-hero-headline layout-grid-item grid-col-10-xl',
        {
          'article-hero-headline__shopping-section-hero': isShoppingSection,
        },
      )}
    >
      {shouldDisplayLiveBlogHeader && (
        liveBlogHeader
      )}
      <HeadlineTagName
        className={classNames(
          className,
          {
            'founders-cond lh-none': !publicoHeadlineBrands.includes(vertical),
            'publico-hed lh-title': publicoHeadlineBrands.includes(vertical),
            'di': isLiveBlog, // eslint-disable-line quote-props
          },
        )}
        data-test="article-hero__headline"
      >
        {childrenToRender}
      </HeadlineTagName>
      <div className={liveBlogDekStyle}>{dek}</div>
    </div>
  );
};

ArticleHeroHeadline.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  dek: PropTypes.node.isRequired,
  isShoppingSection: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  vertical: PropTypes.string.isRequired,
  isLiveBlog: PropTypes.bool,
};

ArticleHeroHeadline.defaultProps = {
  isLiveBlog: false,
};

export default ArticleHeroHeadline;
